import { theme } from 'utils/style/theme';
import React from 'react';
import { Input } from 'antd';
import styled from 'styled-components';
import { IInputCountConifg } from 'utils/types/storyTypes';

// 글자수 카운터가 포함된 일반 input

interface IProps {
  id?: string;
  name?: string;
  defaultValue?: string;
  value?: string;
  onChange?: (e: { target: HTMLInputElement }) => void;
  onClick?: () => void;
  placeholder?: string;
  maxLength?: number;
  disabled?: boolean;
  style?: React.CSSProperties;
  type?: string;
  step?: number;
  status?: 'error' | 'warning';
  pattern?: string;
  width?: string;
  minLength?: number;
  count?: IInputCountConifg;
}

const InputWithCounter: React.FC<IProps> = ({
  value,
  placeholder,
  maxLength,
  count,
  onChange,
  disabled = false,
  type = 'text',
}: IProps) => {
  return (
    <InputStyled
      value={value}
      placeholder={placeholder}
      maxLength={maxLength}
      count={count}
      onChange={onChange}
      disabled={disabled}
      type={type}
    />
  );
};

export default InputWithCounter;

const InputStyled = styled(Input)<IProps>`
  background-color: #fff;
  border: 1px solid ${theme.colors.gray_5};
  border-radius: 0.4rem;
  padding: 4px 36px 4px 16px;
  width: ${(props) => (props.width ? props.width : '100%')};
  min-height: 40px;
  &:hover {
    border: 1px solid #4096ff;
  }
`;
